import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles, Typography, Grid, Button, Theme, Hidden, Switch, Tooltip } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import LocalVideoPreview from './LocalVideoPreview/LocalVideoPreview';
import SettingsMenu from './SettingsMenu/SettingsMenu';
import { Steps } from '../PreJoinScreens';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import ToggleAudioButton from '../../Buttons/ToggleAudioButton/ToggleAudioButton';
import ToggleVideoButton from '../../Buttons/ToggleVideoButton/ToggleVideoButton';
import { useAppState } from '../../../state';
import useChatContext from '../../../hooks/useChatContext/useChatContext';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useKrispToggle } from '../../../hooks/useKrispToggle/useKrispToggle';
import SmallCheckIcon from '../../../icons/SmallCheckIcon';
import InfoIconOutlined from '../../../icons/InfoIconOutlined';
import { LocalAudioTrack } from 'twilio-video';
import axios from 'axios';
const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  marginTop: {
    marginTop: '1em',
  },
  deviceButton: {
    width: '100%',
    border: '2px solid #aaa',
    margin: '1em 0',
  },
  localPreviewContainer: {
    paddingRight: '2em',
    marginBottom: '2em',
    [theme.breakpoints.down('sm')]: {
      padding: '0 2.5em',
    },
  },
  joinButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      width: '100%',
      '& button': {
        margin: '0.5em 0',
      },
    },
  },
  mobileButtonBar: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '1.5em 0 1em',
    },
  },
  mobileButton: {
    padding: '0.8em 0',
    margin: 0,
  },
  toolTipContainer: {
    display: 'flex',
    alignItems: 'center',
    '& div': {
      display: 'flex',
      alignItems: 'center',
    },
    '& svg': {
      marginLeft: '0.3em',
    },
  },
}));

interface DeviceSelectionScreenProps {
  name: string;
  roomName: string;
  setStep: (step: Steps) => void;
}

export default function DeviceSelectionScreen({ name, roomName, setStep }: DeviceSelectionScreenProps) {
  const classes = useStyles();
  const { getToken, isFetching, isKrispEnabled, isKrispInstalled } = useAppState();
  const { connect: chatConnect } = useChatContext();
  const { connect: videoConnect, isAcquiringLocalTracks, isConnecting, localTracks } = useVideoContext();
  const { toggleKrisp } = useKrispToggle();
  const disableButtons = isFetching || isAcquiringLocalTracks || isConnecting;
  const [Joined, setJoined] = useState(false);
  const [MessageString, SetMessageString] = useState('Setting up.');
  const inputElement = React.useRef();
  const { search, state } = useLocation();
  const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
  const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
  const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
  const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
  const Type = (state as { state: { Type: string } }).state.Type;
  const handleJoin = () => {
    //console.log(isAcquiringLocalTracks);
    //console.log(disableButtons, 'disable');

    getToken(name, roomName).then(({ token }) => {
      videoConnect(token);
      process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && chatConnect(token);
    });
  };
  const handleJoin1 = (name: any, roomName: any) => {
    getToken(name, roomName).then(({ token }) => {
      videoConnect(token);
      process.env.REACT_APP_DISABLE_TWILIO_CONVERSATIONS !== 'true' && chatConnect(token);
    });
  };
  // // inputElement.click();
  const functions = () => {
    if (name && roomName && isAcquiringLocalTracks) {
      // //console.log(isAcquiringLocalTracks);
      // //console.log(disableButtons, 'disable');
      // if (Joined == false) {
      //   setJoined(true);
      //   handleJoin();
      // }
    }
    // if (Joined == false) {
    document.getElementById('join')?.click();
    // setJoined(true)
    // }
  };
  // useEffect(() => {
  // setTimeout(() => {
  //   functions();
  // }, 3000);
  // }, []);
  const CheckMeetingRoomStatus = async () => {
    const response = await axios.get(`https://avserver.jobsitecare.com/roomstatus/${ProviderId + RecordId}`);
    //console.log(response);
    if (response.data?.room.length > 0) {
      functions();
    } else {
      if (Type == 'Host') {
        await axios.get(`https://avserver.jobsitecare.com/open/${ProviderId + RecordId}`);
        functions();
      } else {
        SetMessageString('The host will commence the meeting.');
      }
    }
    // if (response.data?.room.length == 0) {
    //   if (Type == 'Patient') {
    //     // //console.log('length');
    //     // await axios.get(`https://avserver.jobsitecare.com/open/${ProviderId + RecordId}`);
    //     SetMessageString('Host will commence the meeting ');
    //   } else {
    //     functions();
    //     // //console.log('length1');
    //   }
    // } else {
    //   //console.log('chala');
    //   if (Type == 'Host') {
    //     await axios.get(`https://avserver.jobsitecare.com/open/${ProviderId + RecordId}`);
    //     functions();
    //   } else {
    //     SetMessageString('Host will commence the meeting ');
    //   }
    // }
  };
  useEffect(() => {
    const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
    const hasAudioTrack = localTracks.some(track => track.kind === 'audio');
    //console.log(audioTrack, 'audioTrack');
    //console.log(hasAudioTrack, 'hasAudioTrack');
    //console.log(isFetching, 'isFetching');
    if (hasAudioTrack) {
      //console.log('chala');
      //console.log(Joined);
      if (!Joined) {
        //console.log('join chala');
        SetMessageString('Setting up.');
        setTimeout(() => {
          CheckMeetingRoomStatus();
        }, 3000);
        setJoined(true);
      }
      // setJoined(true)
    } else {
      SetMessageString('Kindly allow all permissions to proceed into the meeting.');
    }
  }, [localTracks]);

  if (isFetching || isConnecting) {
    return (
      <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
        <div>
          <CircularProgress variant="indeterminate" />
        </div>
        <div>
          {/* <LocalVideoPreview identity={name} />
          <ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
          <ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} /> */}
          <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
            Joining meeting
          </Typography>
        </div>
      </Grid>
    );
  }
  //
  return (
    <Fragment>
      <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
        <div>
          <CircularProgress variant="indeterminate" />
        </div>
        <div>
          {/* <LocalVideoPreview identity={name} />
          <ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
          <ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} /> */}
          <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {MessageString}
          </Typography>
        </div>
      </Grid>
      <div style={{ display: 'none' }}>
        <Typography variant="h5" className={classes.gutterBottom}>
          Join {roomName}
        </Typography>

        <Grid container justifyContent="center">
          <Grid item md={7} sm={12} xs={12}>
            <div className={classes.localPreviewContainer}>
              <LocalVideoPreview identity={name} />
            </div>
            <div className={classes.mobileButtonBar}>
              <Hidden mdUp>
                <ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
                <ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} />
                <SettingsMenu mobileButtonClass={classes.mobileButton} />
              </Hidden>
            </div>
          </Grid>
          <Grid item md={5} sm={12} xs={12}>
            <Grid container direction="column" justifyContent="space-between" style={{ alignItems: 'normal' }}>
              <div>
                <Hidden smDown>
                  <ToggleAudioButton className={classes.deviceButton} disabled={disableButtons} />
                  <ToggleVideoButton className={classes.deviceButton} disabled={disableButtons} />
                </Hidden>
              </div>
            </Grid>
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            {isKrispInstalled && (
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ marginBottom: '1em' }}
              >
                <div className={classes.toolTipContainer}>
                  <Typography variant="subtitle2">Noise Cancellation</Typography>
                  <Tooltip
                    title="Suppress background noise from your microphone"
                    interactive
                    leaveDelay={250}
                    leaveTouchDelay={15000}
                    enterTouchDelay={0}
                  >
                    <div>
                      <InfoIconOutlined />
                    </div>
                  </Tooltip>
                </div>

                <FormControlLabel
                  control={
                    <Switch
                      checked={!!isKrispEnabled}
                      checkedIcon={<SmallCheckIcon />}
                      disableRipple={true}
                      onClick={toggleKrisp}
                    />
                  }
                  label={isKrispEnabled ? 'Enabled' : 'Disabled'}
                  style={{ marginRight: 0 }}
                  // Prevents <Switch /> from being temporarily enabled (and then quickly disabled) in unsupported browsers after
                  // isAcquiringLocalTracks becomes false:
                  disabled={isKrispEnabled && isAcquiringLocalTracks}
                />
              </Grid>
            )}
            <Divider />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <Grid container direction="row" alignItems="center" style={{ marginTop: '1em' }}>
              <Hidden smDown>
                <Grid item md={7} sm={12} xs={12}>
                  <SettingsMenu mobileButtonClass={classes.mobileButton} />
                </Grid>
              </Hidden>

              <Grid item md={5} sm={12} xs={12}>
                <div className={classes.joinButtons}>
                  {/* <Button variant="outlined" color="primary" onClick={() => setStep(Steps.roomNameStep)}>
                  Cancel
                </Button> */}
                  <button onClick={handleJoin} disabled={disableButtons} id="join">
                    Join Now
                  </button>
                  {/* <Button
                  variant="contained"
                  color="primary"
                  data-cy-join-now
                  onClick={handleJoin}
                  disabled={disableButtons}
                  // ref={inputElement}
                >
                  Join Now
                </Button> */}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
}
